import * as React from 'react';
import autobind from 'autobind-decorator';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

// components
import LearningElementsList from '../Components/LearningElementsList';
import LearningElementEdit from '../Components/LearningElementEdit';
import ConceptInfo from "../Components/ConceptInfo";

// interfaces
import { IConceptData } from 'store/StateInterfaces';

// actions
import {
  loadConceptDataRequest,
  deleteConceptElementRequest,
  addConceptElementRequest,
  reorderConceptElementRequest,
  infoEditConceptElementRequest,
} from '../Actions/Actions';

// util
import displayGlobalMessage from 'Utils/DisplayGlobalMessage';
import Forum from 'Screens/Forum/Instructor/Forum';
import Navbar from 'Screens/Layout/Common/Components/Navbar';

//assets
import '../Assets/content_developer.sass';
import '../Assets/jasny-bootstrap.min.sass';
import { Container, Row, Col } from 'react-bootstrap';
import { Card, ButtonToolbar, DropdownButton, Dropdown } from 'react-bootstrap'
import NavigateNextIcon from '@material-ui/icons/NavigateNext';


interface IProps {
  match: any;
  conceptId: number;
  data: IConceptData;
  actions: any;
}

interface IState {
  currentItemIndex: number;
}

class ConceptInstructorPage extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      currentItemIndex: undefined
    }
  }

  componentDidMount() {
    // if (!this.props.data) {
    this.props.actions.loadConceptDataRequest(this.props.conceptId);
    // }
  }
  componentDidUpdate(prevProps) {
    if (prevProps.match.params.conceptId !== this.props.match.params.conceptId) {
      this.props.actions.loadConceptDataRequest(this.props.conceptId);
    }
  }

  @autobind
  onSelectElement(index: number) {
    if (this.state.currentItemIndex === index) {
      this.setState({
        currentItemIndex: undefined
      })
    }
    else {
      this.setState({
        currentItemIndex: index
      })
    }

  }

  @autobind
  onAddElement(type: string, formData: FormData) {
    return this.props.actions.addConceptElementRequest(this.props.conceptId, type, formData);
  }

  @autobind
  onDeleteElement(typeStr: string, typeId: number, id: number) {
    let flag = confirm('Are you Sure?');
    if (flag) {
      this.props.actions.deleteConceptElementRequest(this.props.conceptId, typeStr, typeId, id);
    }
  }

  @autobind
  onReorderElement(payload) {
    let formData = new FormData()
    formData.append('playlist', JSON.stringify(payload));
    return this.props.actions.reorderConceptElementRequest(this.props.conceptId, formData)
      .catch(err => {
        this.props.actions.loadConceptDataRequest(this.props.conceptId);
      })
  }

  @autobind
  onPublishElement() {
    // to be done
  }

  @autobind
  onSaveInfo(data) {
    this.props.actions.infoEditConceptElementRequest(this.props.conceptId, data)
  }

  public render() {
    if (!this.props.data) {
      return (<div>Loading...</div>);
    }

    // create breadcrumb nodes
    const conceptNodes = [];
    this.props.data.group_playlist.forEach((item, i) => {
      conceptNodes.push(
        <li key={item.id} className="dropdown-item"><Link to={`/frontend/concept/${item.id}/`}>{item.title}</Link></li>
      );
    });

    const groupNodes = [];
    this.props.data.course_playlist.forEach((item, i) => {
      if (item.concept.length === 0) {
        groupNodes.push(
          <li key={item.id} className="dropdown-item">
            <Link to={`/frontend/courseware/course/${item.id}`}>{item.title}</Link>
          </li>
        );
      }
      else {

        const cNodes = [];
        item.concept.forEach((result) => {
          cNodes.push(
            <li key={result.id} className="dropdown-item">
              <Link to={`/frontend/concept/${result.id}`}>
                {result.title}
              </Link>
            </li>
          );
        });

        groupNodes.push(
          <li key={item.id} className="dropdown-submenu">
            <Link className="dropdown-item" to={`/frontend/courseware/course/${item.id}`}>
              {item.title}
            </Link>
            <ul className="dropdown-menu">
              {cNodes}
            </ul>
          </li>
        );

      }

    });


    // get forum
    let forum = null;
    if (this.props.data.tag) {
      forum = <Forum id={this.props.data.forum} />
    }

    return (
      <React.Fragment>
        <Navbar navbarClass='navbar-light' />

        <Container>
          {/* concept heading */}
          <Row>
            <Col md={{ span: 12 }}>
              <h3 className="course-title">
                <Link to={`frontend/courseware/course/${this.props.data.course} /`}>
                  {this.props.data.course_title}
                </Link>
              </h3>
            </Col>
          </Row>

          {/* concept content */}
          <Row>
            <Col md={12}>
              <Card>

                {/* breadcrumb */}
                <Container style={{ maxHeight: '50px', maxWidth: '90%' }}>
                  <Row>
                    <div style={{ marginTop: '1%' }}>
                      <div className="dropdown">
                        <button className="btn btn-light dropdown-toggle"
                          style={{ fontSize: '21px' }}
                          type="button" id="dropdownMenu1"
                          data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          {this.props.data.group_title}
                        </button>
                        <ul className="dropdown-menu multi-level" role="menu" aria-labelledby="dropdownMenu">
                          <li className="dropdown-item">Other Topics</li>
                          <li className="dropdown-divider"></li>
                          {groupNodes}
                        </ul>
                      </div>
                    </div>
                    <div style={{ marginTop: '2%' }}>
                      <NavigateNextIcon />
                    </div>
                    <div style={{ marginTop: '1%' }}>
                      <div className="dropdown">
                        <button className="btn btn-light dropdown-toggle"
                          style={{ fontSize: '21px' }}
                          type="button" id="dropdownMenu1" data-toggle="dropdown"
                          aria-haspopup="true" aria-expanded="false">
                          {this.props.data.title}
                        </button>
                        <ul className="dropdown-menu multi-level" role="menu" aria-labelledby="dropdownMenu">
                          <li className="dropdown-item">Other Sections</li>
                          <li className="dropdown-divider"></li>
                          {conceptNodes}
                        </ul>
                      </div>
                    </div>
                  </Row>
                </Container>
                <hr />
                <Card.Body>
                  <Container style={{ maxWidth: '90%' }}>

                    {/* concept info */}
                    <Row>
                      <Col md={12}>
                        <ConceptInfo
                          title={this.props.data.title}
                          description={this.props.data.description}
                          onSaveInfoCallback={this.onSaveInfo}
                        />
                      </Col>
                    </Row>

                    {/* learning elements list */}
                    <Row>
                      <Col md={12}>
                        <LearningElementsList
                          playlist={this.props.data.playlist}
                          onSelectCallback={this.onSelectElement}
                          onAddCallback={this.onAddElement}
                          onDeleteCallback={this.onDeleteElement}
                          onPublishCallback={this.onPublishElement}
                          onReorderCallback={this.onReorderElement}
                        />
                      </Col>
                    </Row>

                  </Container>

                </Card.Body>
              </Card>
            </Col>
          </Row>

          <br />
          {/* concept edit */}
          {this.state.currentItemIndex !== undefined ?
            <Row>
              <Col md={12}>
                <LearningElementEdit
                  data={this.props.data.playlist[this.state.currentItemIndex]}
                  concept={this.props.conceptId}
                  refresh={() => { this.props.actions.loadConceptDataRequest(this.props.conceptId) }}
                // props here 
                />
              </Col>
            </Row>
            : null
          }

          {/* discussion forum */}
          <br />
          <Row>
            <Col md={12}>
              {forum}
            </Col>
          </Row>

        </Container>
      </React.Fragment>
    )
  }
}

interface IReduxState {
  instructorConceptDataMap: Map<number, IConceptData>;
}

const mapStateToProps = (state: IReduxState, { match }) => {
  const conceptId = match.params.conceptId;
  let data = undefined;
  if (state.instructorConceptDataMap.has(conceptId)) {
    data = state.instructorConceptDataMap.get(conceptId)
  }

  return {
    match,
    conceptId,
    data
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    loadConceptDataRequest,
    deleteConceptElementRequest,
    addConceptElementRequest,
    reorderConceptElementRequest,
    infoEditConceptElementRequest,

  }, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(ConceptInstructorPage);